import { useState } from "react";
import { Layout } from "../components/Layout";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { ShieldCheck, Save } from "lucide-react";
import { PhotoUpload } from "../components/PhotoUpload";
import { ROLE_LABELS } from "../lib/re";

export default function Perfil() {
  const { user, refreshUser } = useAuth();
  const [form, setForm] = useState({
    name: user.name || "", phone: user.phone || "", title: user.title || "", whatsapp: user.whatsapp || "",
  });
  const [pw, setPw] = useState("");
  const [curPw, setCurPw] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = { ...form };
      if (pw) { payload.password = pw; payload.current_password = curPw; }
      await api.patch(`/users/${user.id}`, payload);
      await refreshUser();
      setPw(""); setCurPw("");
      toast.success("Perfil atualizado");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    setSaving(false);
  };

  return (
    <Layout title="O Meu Perfil">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="card-almar p-6 text-center">
          <div className="relative w-28 h-28 mx-auto">
            <img src={user.photo_url || "https://ui-avatars.com/api/?name=" + encodeURIComponent(form.name)} data-testid="profile-photo"
              alt="" className="w-28 h-28 rounded-full object-cover ring-2 ring-[#C9A84C]/40" />
            <PhotoUpload userId={user.id} onDone={refreshUser} testId="profile-photo-upload" />
          </div>
          <p className="text-[11px] text-slate-500 mt-2">Clique na câmara para carregar a sua fotografia</p>
          <h3 className="font-display text-xl text-slate-100 mt-4">{form.name}</h3>
          <p className="text-sm text-[#E0C574]">{form.title}</p>
          <span className={`inline-flex items-center gap-1 mt-3 text-xs px-3 py-1 rounded-full border ${user.role === "admin" ? "bg-[#C9A84C]/20 text-[#E0C574] border-[#C9A84C]/40" : "bg-slate-800 text-slate-300 border-slate-700"}`}>
            <ShieldCheck size={12} /> {ROLE_LABELS[user.role] || user.role}
          </span>
          <p className="text-xs text-slate-500 mt-4 break-all">{user.email}</p>
        </div>

        <div className="card-almar p-6 lg:col-span-2">
          <h3 className="font-display text-lg text-slate-100 mb-4">Editar Dados</h3>
          <form onSubmit={save} className="space-y-3">
            <div>
              <label className="text-xs uppercase tracking-wider text-[#C9A84C]">Nome</label>
              <input className="input-almar mt-1" data-testid="profile-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="text-xs uppercase tracking-wider text-[#C9A84C]">Telefone</label>
                <input className="input-almar mt-1" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              </div>
              <div>
                <label className="text-xs uppercase tracking-wider text-[#C9A84C]">WhatsApp</label>
                <input className="input-almar mt-1" value={form.whatsapp} onChange={(e) => setForm({ ...form, whatsapp: e.target.value })} />
              </div>
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-[#C9A84C]">Cargo</label>
              <input className="input-almar mt-1" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-[#C9A84C]">Nova palavra-passe (opcional)</label>
              <input className="input-almar mt-1" type="password" placeholder="Deixe vazio para manter" data-testid="profile-password-input" value={pw} onChange={(e) => setPw(e.target.value)} />
              {pw && <input className="input-almar mt-2" type="password" placeholder="Palavra-passe atual" data-testid="profile-current-password-input" value={curPw} onChange={(e) => setCurPw(e.target.value)} />}
            </div>
            <button type="submit" disabled={saving} data-testid="profile-save-btn"
              className="flex items-center gap-2 bg-[#C9A84C] hover:bg-[#D9B85C] text-[#0D1B2A] font-semibold px-5 py-2.5 rounded-lg transition-all disabled:opacity-60">
              <Save size={17} /> {saving ? "A guardar..." : "Guardar Alterações"}
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
}
